module.exports = __webpack_public_path__ + "img/icon-prev.6efd449.svg";